import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import useUnauthorizedHandler from "../snippet/useUnauthorizedHandler";
import { debounce } from "../snippet/Debouncing";
import { useSelector } from "react-redux";
import { GetWorkersSubmittedDocsReport } from "../../actions/admin-provider/reports/GetWorkersSubmittedDocsReport";

function DocMultiSelectDropdown({
  title,
  updateFilter,
  provider_org_ids,
  worker_ids,
  Path
  //   setDoc_ids,
  //     document_ids,
}) {
  const AllFunctions = useSelector((state) => state.allFunctions);
  const [document_ids, setDoc_ids] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [items, setItems] = useState([]);
  const [loadData, setLoadData] = useState(true);
  const [checkData, setCheckData] = useState(false);
  const dropdownRef = useRef(null);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const dispatch = useDispatch();
  const lastFetchKeyRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSeachChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const inputchangeSearch = useCallback(debounce(handleSeachChange), []);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (item) => {
    setCheckData(true);
    const newEntry = parseInt(item.document_id, 10);

    const exists = document_ids.includes(newEntry);

    if (exists) {
      setDoc_ids(
        document_ids.filter((entry) => entry !== newEntry)
      );
    } else {
      setDoc_ids([...document_ids, newEntry]);
    }
  };
  const clearSelection = () => {
    setCheckData(true);
    setDoc_ids([]);
  };

  const GetClientIdData = useCallback(
    async (provider_org_ids, worker_ids, Path) => {
      const providerIds = Array.isArray(provider_org_ids)
        ? provider_org_ids.map((item) =>
            item && typeof item === "object" && item?.provider_org_id != null
              ? item.provider_org_id
              : item
          )
        : [];

      const workerIds = Array.isArray(worker_ids)
        ? worker_ids.map((item) =>
            item && typeof item === "object" && item?.worker_id != null
              ? item.worker_id
              : item
          )
        : [];

      const normalizedProviderIds = providerIds.filter(
        (value) => value !== undefined && value !== null && value !== ""
      );

      const normalizedWorkerIds = workerIds.filter((value) =>
        value !== undefined && value !== null && value !== ""
      );

      const requestKey = JSON.stringify({
        providerIds: normalizedProviderIds,
        workerIds: normalizedWorkerIds,
        search: searchTerm.trim().toLowerCase(),
      });

      if (lastFetchKeyRef.current === requestKey) {
        return;
      }

      lastFetchKeyRef.current = requestKey;
      setLoadData(false);

      dispatch(
        GetWorkersSubmittedDocsReport(
          {
            ...(normalizedProviderIds.length
              ? { provider_org_ids: JSON.stringify(normalizedProviderIds) }
              : {}),
            ...(normalizedWorkerIds.length
              ? { worker_ids: JSON.stringify(normalizedWorkerIds) }
              : {}),
            search: searchTerm,
          },
          Path
        )
      ).then((response) => {
        if (response?.status === 401) {
          lastFetchKeyRef.current = null;
          handleUnauthorizedAccess();
          return;
        }

        if (response?.success === true) {
          const arrayData = Array.isArray(response?.data)
            ? response.data.map((item) => ({
                name: item.doc_name,
                document_id: item.document_id,
              }))
            : [];
          setItems(arrayData);
        } else {
          setItems([]);
        }
        setLoadData(true);
      });
      // eslint-disable-next-line
    },
    [dispatch, searchTerm, handleUnauthorizedAccess]
  );

  useEffect(() => {
    GetClientIdData(provider_org_ids, worker_ids, Path);
  }, [searchTerm, provider_org_ids, worker_ids, GetClientIdData]);

  useEffect(() => {
    if (checkData) {
      updateFilter("document_ids", document_ids);
    }
  }, [document_ids]);

  return (
    <div className="relative inline-block text-left w-32" ref={dropdownRef}>
      {/* Dropdown button */}
      <button
        onClick={toggleDropdown}
        type="button"
        className="flex items-center justify-between w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500"
      >
        <span>{title}</span>
        {document_ids?.length > 0 && (
          <span className="inline-flex ml-1 items-center justify-center w-6 h-6 text-sm font-semibold text-blue-700 bg-blue-100 rounded-full">
            {document_ids.length}
          </span>
        )}
        <svg
          className="w-5 h-5 ml-2 text-gray-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Dropdown panel */}
      {isOpen && (
        <div className="absolute left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-10">
          {/* Header row: 'X document_ids' and Clear button */}
          <div className="flex items-center justify-between p-2 border-b border-gray-200">
            <span className="text-sm text-gray-500">
              {document_ids.length} selected
            </span>
            <button
              type="button"
              className="text-sm text-blue-600 hover:underline focus:outline-none"
              onClick={clearSelection}
            >
              Clear
            </button>
          </div>

          {/* Search input */}
          <div className="p-2">
            <input
              type="text"
              placeholder="Type here"
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              // value={searchTerm}
              onChange={(e) => inputchangeSearch(e)}
            />
          </div>

          {/* Scrollable list of items */}
          <ul className="max-h-48 overflow-y-auto">
            {items?.map((item) => (
              <li
                key={item.checklist_id}
                className="flex items-center px-3 py-2 hover:bg-gray-50"
              >
                <input
                  type="checkbox"
                  className="w-4 h-4 mr-2 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  // checked={document_ids?.induction_id.includes(parseInt(item.id, 10))}
                  checked={document_ids?.includes(
                    parseInt(item.document_id, 10)
                  )}
                  onChange={() => handleSelect(item)}
                />
                <span className="text-sm text-gray-700">{item.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
export default DocMultiSelectDropdown;
